import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/references";

export default {
  async getAllPreliminary(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}/preliminary`, options);
    return response.data;
  },

  async getTeacherReferences(teacherId) {
    return (await HTTP.get(`${RESOURCE_NAME}/teacherReferences/${teacherId}`))
      .data;
  },

  async downloadReferenceFile(id) {
    return HTTP.get(`${RESOURCE_NAME}/reference/${id}/file`, {
      responseType: "blob",
    });
  },

  async requestTeacherReference(entity) {
    return (await HTTP.post(`${RESOURCE_NAME}/requestReference`, entity)).data;
  },

  async get(id) {
    return (await HTTP.get(`${RESOURCE_NAME}/${id}`)).data;
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },

  async delete(id) {
    return await HTTP.delete(`${RESOURCE_NAME}/${id}`);
  },
};
